import React from 'react';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ThrowInDev from 'Helpers/ThrowInDev';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { pick } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { FDStack } from '@facet-wealth/design';
import { RoadmapDeliverableWrapperLayout } from '../../RoadmapDeliverable/Wrapper/RoadmapDeliverableWrapperLayout';
import { TaxStrategyDetailsLayout } from './Content/TaxStrategyDetailsLayout';
import TaxStrategyDetailsMetaOverride from './Content/TaxStrategyDetailsMetaOverride';

const RenderTax = () => {
  const { resource } = useMetaLayoutContext();
  const taxResource = resource.attr('details')?.resources()?.head();
  if (!taxResource) {
    return <ThrowInDev err="Missing tax resource to render!" />;
  }
  return (
    <MetaResourceRenderer
      resource={taxResource}
      layout={TaxStrategyDetailsLayout}
      metaOverrideSet={TaxStrategyDetailsMetaOverride}
    />
  );
};
const RenderTaxWithPaddingAbove = () => {
  return <><FDStack paddingY={2} /><RenderTax /></>;
};
const RenderTaxInGuidedHouseholdReviewLayout = withGuidedHouseholdReviewLayout(RenderTaxWithPaddingAbove, {
  fullWidth: true,
  hideTitle: true,
});
const RenderTaxInRoadmapDeliverableLayout = () => {
  return <RoadmapDeliverableWrapperLayout><RenderTax /></RoadmapDeliverableWrapperLayout>;
};

export default function ProposalScenarioTaxStrategyDetailsStepTemplate({ resource }) {
  const { setPageContentCollection } = usePageContentContext();
  const Layout = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: RenderTaxInGuidedHouseholdReviewLayout,
    [fr.relationships.roadmapDeliverableLayout.name]: RenderTaxInRoadmapDeliverableLayout,
  }, RenderTax);
  return (
    <MetaResourceRenderer
      resource={resource}
      onSubmit={setPageContentCollection}
      layout={Layout}
    />
  );
}
